<template>
  <section class="box">
    <div class="filters">
      <FilterSelect
        label="קטגוריה"
        :items="categories"
        itemTitle="name"
        itemValue="id"
        filterKey="products"
      />
    </div>
    <DynamicTable
      :headers="headers"
      :data="filteredProducts"
      :searchQuery="searchQuery"
      @action="handleAction"
      @route="editProduct"
    />
  </section>
</template>

<script>
// import { mapGetters } from "vuex";
import DynamicTable from "../helpers/DynamicTable.vue";
import FilterSelect from "../helpers/FilterSelect.vue";

export default {
  components: {
    DynamicTable,
    FilterSelect,
  },
  data() {
    return {
      searchQuery: "",
      headers: [
        { key: "name", label: "שם המוצר" },
        { key: "originPrice", label: "מחיר" },
        { key: "discountPrice", label: "מחיר אחרי הנחה" },
        { key: "category", label: "קטגוריה" },
        { key: "AvailableInStock", label: "מלאי" },
        { type: "actions", key: "actions", label: "פעולות" },
      ],
      products: [
        {
          sku: "144",
          name: "סרט קשירה 100Y",
          originPrice: 200,
          images: [
            "/images/product-06.jpg",
            "/images/product-05.jpg",
            "/images/product-04.jpg",
            "/images/product-03.jpg",
            "/images/product-06.jpg",
          ],
          image: "/images/testImg.png",
          discountPrice: 150,
          discountPercent: 25,
          AvailableInStock: true,
          height: "מטר 1 ",
          package: 10,
          description:
            "לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית קולהע צופעט למרקוח איבן איף, ברומץ כלרשט מיחוצים. קלאצי סחטיר בלובק. תצטנפל בלינדו למרקל אס לכימפו, דול, צוט ומעיוט - לפתיעם ברשג - ולתיעם גדדיש. קוויז דומור ליאמום בלינך רוגצה. לפמעט",
          quantity: 1,
        },
      ],
    };
  },
  mounted() {
    // this.docsList = this.OrdersToAprove;
    // this.$store.dispatch("fetchProducts");
    // this.$store.dispatch("fetchCategories");
  },
  methods: {
    handleAction({ type, row }) {
      if (type === "edit") {
        this.editProduct(row.part);
      }
    },
    editProduct(productId) {
      this.$router.push(`/admin/products/${productId}/edit`);
    },
  },
  computed: {
    // ...mapGetters(["products", "categories"]),
    filteredProducts() {
      let filtered = [...this.products];
      const categoryId = this.$route.query.category;

      if (categoryId) {
        filtered = filtered.filter(
          (product) => product.categoryId === categoryId
        );
      }

      return filtered;
    },
  },
};
</script>

<style scoped>
.box {
  padding: 20px;
}
.filters {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}
</style>